export default __webpack_public_path__ + "static/media/about-img1.7f25d5df.png";